/**
 * Blog post metadata for the blog index. Full content is rendered by dedicated components in components/blog/.
 * Each post has its own URL: /:lang/blog/:slug for SEO.
 * Bump BLOG_IMAGE_VERSION when replacing blog images so browsers and the PWA cache load the new files.
 */
const BLOG_IMAGE_VERSION = 'v3';

export const BLOG_POSTS = [
  {
    slug: 'telc-b1-redemittel-schreiben',
    title: 'TELC B1 German Exam: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'Redemittel are the fixed phrases that carry an exam answer: how you open a letter, give your opinion, make a suggestion or end a conversation politely. The telc B1 phrases for Schreiben and Sprechen, sorted by task, with English meanings, examples and a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Redemittel for telc B1 Schreiben and Sprechen: real phrases with English meanings, examples, and when each one earns marks. Full list as a free PDF.',
    category: 'TELC B1',
    date: '2026-01-01',
    dateFormatted: '1. January 2026',
    image: `/images/blog/telc-b1-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_TELC_B1_Redemittel_Guide.pdf',
    readTime: '5 min read',
  },
  {
    slug: 'telc-b2-redemittel-schreiben',
    title: 'TELC B2 German Exam: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'The telc B2 Redemittel for the formal letter and the oral exam (presentation, discussion, planning), sorted by task, with English meanings, example sentences and the complete list as a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Redemittel for telc B2 Schreiben and Sprechen, with English meanings, worked examples and the exam task each phrase fits. Full list as a free PDF.',
    category: 'TELC B2',
    date: '2026-01-05',
    dateFormatted: '5. January 2026',
    image: `/images/blog/telc-b2-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_TELC_B2_Redemittel_Guide.pdf',
    readTime: '6 min read',
  },
  {
    slug: 'telc-c1-redemittel-schreiben',
    title: 'TELC C1 Hochschule German Exam: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'To secure the telc deutsch c1 certification, candidates must execute precise academic phrasing. This definitive guide provides the exact Redemittel for the written and oral part, essential study tips, and preparation material as a free PDF download. The Schriftlicher Ausdruck is a single task: one argumentative text of at least 350 words in 70 minutes.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Academic Redemittel for telc C1 Hochschule Schreiben and Sprechen: phrases, English meanings and examples for the 70-minute essay and the oral exam. Free PDF included.',
    category: 'TELC C1',
    date: '2026-01-08',
    dateFormatted: '8. January 2026',
    image: `/images/blog/telc-c1-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_TELC_C1_Redemittel_Guide.pdf',
    readTime: '6 min read',
  },
  {
    slug: 'goethe-b1-redemittel-schreiben',
    title: 'Goethe-Zertifikat B1: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'The Goethe-Zertifikat B1 Redemittel for Schreiben (three tasks in 60 minutes) and Sprechen, sorted by task, with English meanings, example sentences and the complete list as a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Goethe-Zertifikat B1 Redemittel for Schreiben and Sprechen: the phrases that score, with English meanings and examples for all three writing tasks.',
    category: 'Goethe B1',
    date: '2026-01-12',
    dateFormatted: '12. January 2026',
    image: `/images/blog/goethe-b1-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_GOETHE_B1_Redemittel_Guide.pdf',
    readTime: '5 min read',
  },
  {
    slug: 'goethe-b2-redemittel-schreiben',
    title: 'Goethe-Zertifikat B2: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'The Goethe B2 Redemittel for Schreiben (forum post and formal message) and Sprechen (presentation and discussion), with English meanings, example sentences and a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Goethe B2 Redemittel for Schreiben and Sprechen, with English meanings and examples for each task. Download the complete phrase list as a free PDF.',
    category: 'Goethe B2',
    date: '2026-01-15',
    dateFormatted: '15. January 2026',
    image: `/images/blog/goethe-b2-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_GOETHE_B2_Redemittel_Guide.pdf',
    readTime: '6 min read',
  },
  {
    slug: 'goethe-c1-redemittel-schreiben',
    title: 'Goethe-Zertifikat C1: Academic Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'Academic Redemittel for the Goethe-Zertifikat C1 Schreiben and Sprechen: how to introduce a topic, qualify a claim and summarise a discussion, with English meanings, examples and a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Goethe C1 Redemittel for Schreiben and Sprechen: academic phrases with English meanings and examples for every task. Complete list as a free PDF.',
    category: 'Goethe C1',
    date: '2026-01-19',
    dateFormatted: '19. January 2026',
    image: `/images/blog/goethe-c1-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_GOETHE_C1_Redemittel_Guide.pdf',
    readTime: '6 min read',
  },
  {
    slug: 'osd-b1-redemittel-schreiben',
    title: 'ÖSD Zertifikat B1: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'ÖSD Zertifikat B1 Redemittel for Schreiben and Sprechen, sorted by task, with English meanings, example sentences and the complete list as a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'ÖSD Zertifikat B1 Redemittel for Schreiben and Sprechen: Austrian-German phrases with English meanings and examples for each task. Free PDF list.',
    category: 'ÖSD B1',
    date: '2026-01-22',
    dateFormatted: '22. January 2026',
    image: `/images/blog/osd-b1-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_OSD_B1_Redemittel_Guide.pdf',
    readTime: '5 min read',
  },
  {
    slug: 'osd-b2-redemittel-schreiben',
    title: 'ÖSD Zertifikat B2: Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'ÖSD Zertifikat B2 Redemittel for formal correspondence, argumentative writing and the oral exam, with English meanings, example sentences and the complete list as a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'ÖSD B2 Redemittel for Schreiben and Sprechen, with English meanings, examples and the task each phrase belongs to. Full list available as a free PDF.',
    category: 'ÖSD B2',
    date: '2026-01-26',
    dateFormatted: '26. January 2026',
    image: `/images/blog/osd-b2-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_OSD_B2_Redemittel_Guide.pdf',
    readTime: '6 min read',
  },
  {
    slug: 'osd-c1-redemittel-schreiben',
    title: 'ÖSD Zertifikat C1: Academic Redemittel Schreiben & Sprechen (PDF)',
    excerpt:
      'Academic Redemittel for the ÖSD Zertifikat C1: phrases for formal writing, describing data and arguing a position, plus the oral exam, with English meanings, examples and a free PDF.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'ÖSD C1 Redemittel for Schreiben and Sprechen: academic phrases with English meanings and examples for every task. Download the full list free.',
    category: 'ÖSD C1',
    date: '2026-01-29',
    dateFormatted: '29. January 2026',
    image: `/images/blog/osd-c1-redemittel-schreiben.png?${BLOG_IMAGE_VERSION}`,
    pdfUrl: '/data/redemittel/LOGAMI_OSD_C1_Redemittel_Guide.pdf',
    readTime: '6 min read',
  },
  {
    slug: 'goethe-vs-telc',
    title: 'Goethe vs. TELC: Which German Exam is Better for Visas and University?',
    excerpt:
      'Deciding between Goethe vs. TELC? Discover how your choice influences university admissions and visas, what to choose if you have weak grammar, and how to pass.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Goethe or telc? Compare cost, format, difficulty and which certificate universities, employers and immigration offices actually accept at B1 to C1.',
    category: 'Exam Guide',
    date: '2026-02-02',
    dateFormatted: '2. February 2026',
    image: `/images/blog/goethe-telc.png?${BLOG_IMAGE_VERSION}`,
    readTime: '7 min read',
  },
  {
    slug: 'goethe-b2-exam-guide',
    title: 'How to Pass the Goethe B2 Exam: Practice Tests & Strategy',
    excerpt:
      "You've reached B2 level, now the Goethe-Zertifikat B2 stands between you and your goals. Here is your roadmap: strategy for Schreiben, Sprechen, Lesen & Hören, plus why simulation beats study.",
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Taking the German B2 test? What the Goethe B2 exam contains module by module, the points you need to pass, and a free full-length practice test.',
    category: 'Goethe B2',
    date: '2026-02-05',
    dateFormatted: '5. February 2026',
    image: `/images/blog/goethe-b2-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '8 min read',
  },
  {
    slug: 'telc-b1-exam-guide',
    title: 'TELC B1 Exam Success: The Teachers Guide to Passing',
    excerpt:
      "The difference between Nicht Bestanden and Bestanden isn't just how much German you know, it's how well you know the exam. A teacher's blueprint for vocabulary, sections, and mock exams.",
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'The telc B1 exam pattern in full: all four parts, timings, the points needed to pass, and what examiners reward. Plus a free full-length practice test.',
    category: 'TELC B1',
    date: '2026-02-09',
    dateFormatted: '9. February 2026',
    image: `/images/blog/telc-b1-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'telc-b2-exam-guide',
    title: 'telc B2 Prüfung & Exam: Aufbau, Punkte, Bestehen',
    excerpt:
      'Die telc B2 Prüfung im Überblick: alle fünf Teile mit Zeiten und Punkten, Bestehensgrenze, der Schriftliche Ausdruck und telc oder Goethe.',
    // Written for the SERP, not the blog index. Target queries from GSC: "telc b2 prüfung", "telc b2 exam".
    metaDescription:
      'telc B2 Prüfung / exam: Aufbau, Zeiten und Punkte (300 gesamt, 60 % zum Bestehen), der Schriftliche Ausdruck, telc oder Goethe und ein kostenloser Modelltest.',
    category: 'TELC B2',
    date: '2026-02-12',
    dateFormatted: '12. February 2026',
    image: `/images/blog/telc-b2-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '7 min read',
  },
  {
    slug: 'telc-c1-exam-guide',
    title: 'telc C1 Prüfung: Aufbau, Punkte & Hochschule vs. Allgemein',
    excerpt:
      'Die telc C1 Prüfung im Überblick: Aufbau, Zeiten und Punkte von telc Deutsch C1 Hochschule, die Bestehensgrenze und der Unterschied zu C1 Allgemein.',
    // Written for the SERP, not the blog index. Target queries from GSC: "telc c1", "telc c1 prüfung".
    metaDescription:
      'telc C1 Prüfung: Aufbau, Zeiten und Punkte (214 gesamt, 60 % zum Bestehen), Hochschule vs. Allgemein und ein kostenloser Modelltest zum Üben.',
    category: 'TELC C1',
    date: '2026-02-16',
    dateFormatted: '16. February 2026',
    image: `/images/blog/telc-c1-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'goethe-b1-exam-guide',
    title: 'Goethe B1 Exam Modeltest & Guide: Master All 4 Modules',
    excerpt:
      'Dein Fahrplan zum Goethe-Zertifikat B1: 4 Module, Goethe vs. telc B1, Redemittel und 3 Tipps, um die Prüfung mit System zu bestehen.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Goethe-Zertifikat B1 model test and guide: all four modules, timings, the points you need per module, and what happens if you fail just one.',
    category: 'Goethe B1',
    date: '2026-02-19',
    dateFormatted: '19. February 2026',
    image: `/images/blog/goethe-b1-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'goethe-c1-exam-guide',
    title: 'Goethe C1 Mastery 2026: New Format Strategies & Advanced Précis Training',
    excerpt:
      'Das Goethe-Zertifikat C1: neues Format, vier Module, High-Level Academic Précis und Goethe vs. telc C1. Dein Weg zum akademischen Erfolg.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'Goethe-Zertifikat C1 in the 2026 format: what changed, all four modules, the marks needed to pass, and a free full-length C1 practice test.',
    category: 'Goethe C1',
    date: '2026-02-23',
    dateFormatted: '23. February 2026',
    image: `/images/blog/goethe-c1-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'osd-c1-exam-guide',
    title: 'ÖSD Zertifikat C1: Expert Strategies for Complex Topics & High Scores',
    excerpt:
      'ÖSD C1: plurizentrische Vielfalt, komplexe gesellschaftliche Themen, Prüfungsaufbau und Redemittel-Strategien. Dein ultimatives Prüfungstraining.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'ÖSD Zertifikat C1 explained: exam structure, Austrian-German expectations, the points needed to pass each module, and a free full-length practice test.',
    category: 'ÖSD C1',
    date: '2026-02-26',
    dateFormatted: '26. February 2026',
    image: `/images/blog/osd-c1-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'osd-b2-exam-guide',
    title: 'ÖSD B2 Mock Exam: Master Austrian German & Listening with Real Teachers',
    excerpt:
      'ÖSD Zertifikat B2: plurizentrische Breite, österreichische Nuancen, Two-Modules-System und Redemittel. Dein Erfolgsweg zum B2 Zertifikat.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'ÖSD B2 online test and guide: the two-module system, Austrian-German specifics, the points needed to pass, and a free full-length ÖSD B2 mock exam.',
    category: 'ÖSD B2',
    date: '2026-03-01',
    dateFormatted: '1. March 2026',
    image: `/images/blog/osd-b2-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'telc-b2-schreiben-guide',
    title: 'telc B2 Schreiben: Aufbau, Model Letter & Scoring (2026)',
    excerpt:
      'The telc B2 Schreiben section is a structure test: 30 minutes, one formal letter, three of four Leitpunkte. Complete guide with the official scoring criteria, a five-paragraph template, and a full model Beschwerdebrief.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'telc B2 Schreiben: Aufbau (structure), 30 minutes, 150+ words, three of four Leitpunkte. Marking scheme, a template and a full model Beschwerdebrief.',
    category: 'TELC B2',
    date: '2026-07-28',
    dateFormatted: '28. July 2026',
    image: `/images/blog/telc-b2-schreiben-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '8 min read',
  },
  {
    slug: 'telc-b1-schreiben-guide',
    title: 'TELC B1 Schreiben Guide: Structure, Model Email & Scoring (2026)',
    excerpt:
      'The telc B1 Schreiben section: 30 minutes, one letter or email, three of four Leitpunkte. Complete guide with the scoring criteria, a four-paragraph template, and a full model email at exam level.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'telc B1 Schreiben structure: 30 minutes, one letter or email, three of four Leitpunkte. Scoring criteria, a four-paragraph template and a model email.',
    category: 'TELC B1',
    date: '2026-07-28',
    dateFormatted: '28. July 2026',
    image: `/images/blog/telc-b1-schreiben-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '7 min read',
  },
  {
    slug: 'telc-c1-schreiben-guide',
    title: 'TELC C1 Hochschule Schreiben Guide: Essay Structure & Model Paragraphs',
    excerpt:
      'The telc C1 Hochschule Schriftlicher Ausdruck: 70 minutes, one academic text of around 350 words. Essay skeleton, the four scoring criteria, model Einleitung and Fazit, and the mistakes that cost the most points.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'telc C1 Hochschule Schriftlicher Ausdruck: 70 minutes, one 350-word academic text. Essay skeleton, the four scoring criteria, model Einleitung and Fazit.',
    category: 'TELC C1',
    date: '2026-07-28',
    dateFormatted: '28. July 2026',
    image: `/images/blog/telc-c1-schreiben-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '8 min read',
  },
  {
    slug: 'online-mock-exams-vs-real-exam',
    title: 'Online Mock Exams vs. the Real German Exam: What Is Actually Different?',
    excerpt:
      'If you pass the mock, will you pass the real telc, Goethe or ÖSD exam? What an online simulator replicates exactly, what changes on exam day, and the readiness rule that tells you when to book.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'What an online mock exam copies exactly, what changes on exam day, and the readiness rule that tells you when to book your telc, Goethe or ÖSD test.',
    category: 'Exam Guide',
    date: '2026-07-28',
    dateFormatted: '28. July 2026',
    image: `/images/blog/online-mock-exams-vs-real-exam.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'how-long-prepare-german-exam',
    title: 'How Long Does It Take to Prepare for German B1, B2 or C1?',
    excerpt:
      'Honest hour benchmarks for B1, B2 and C1, step distances between levels, and the 4 to 8 week exam-specific phase almost everyone underestimates. Includes an 8-week preparation plan.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'How long German B1, B2 and C1 really take: honest hour benchmarks per level, the gap between each step, and the exam phase most people underestimate.',
    category: 'Exam Guide',
    date: '2026-07-28',
    dateFormatted: '28. July 2026',
    image: `/images/blog/how-long-prepare-german-exam.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'osd-b1-exam-guide',
    title: 'ÖSD B1 Exam Guide: Structure, Points and Pass Mark (ZDÖ B1)',
    excerpt:
      'The ÖSD B1 (ZDÖ B1) explained: a written part worth 225 points, a separate oral exam worth 75, what you need to pass, and how to prepare.',
    // Written for the SERP, not the blog index. Target query from GSC.
    metaDescription:
      'ÖSD B1 (ZDÖ B1) guide: the written part is worth 225 points and you pass with 135. Structure, points per section, the oral exam, and a free ÖSD B1 mock exam.',
    category: 'ÖSD B1',
    date: '2026-03-02',
    dateFormatted: '2. March 2026',
    image: `/images/blog/osd-b1-guide.png?${BLOG_IMAGE_VERSION}`,
    readTime: '6 min read',
  },
  {
    slug: 'telc-b1-sprechen-sample-exams',
    title: 'telc B1 Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete telc B1 oral exam samples: the exam sheets for all three parts, a model dialogue between two candidates for each part, the reusable phrases marked, and a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "telc b1 sprechen beispiel".
    metaDescription:
      'telc B1 Sprechen sample exams: real-format sheets for Teil 1, 2 and 3, model dialogues with the key phrases marked, scoring criteria and a printable PDF.',
    category: 'TELC B1',
    date: '2026-09-16',
    dateFormatted: '16. September 2026',
    image: `/images/blog/sprechen/telc-b1/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    // Optional: hero alt text when the image shows more than the title says.
    imageAlt: 'telc B1 oral exam sample sheets for Teil 2 and Teil 3 lying on a desk',
    readTime: '8 min read',
  },
  {
    slug: 'telc-b2-sprechen-sample-exams',
    title: 'telc B2 Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete telc B2 oral exam samples: the Präsentation, Diskussion and Problemlösung sheets, a model dialogue for every part with the reusable phrases marked, and a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "telc b2 mündliche prüfung beispiel".
    metaDescription:
      'telc B2 Sprechen sample exams: real-format sheets for Präsentation, Diskussion and Problemlösung, model dialogues with the key phrases marked, scoring and a printable PDF.',
    category: 'TELC B2',
    date: '2026-09-19',
    dateFormatted: '19. September 2026',
    image: `/images/blog/sprechen/telc-b2/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'telc B2 oral exam sample sheets for the presentation and the discussion lying on a desk',
    readTime: '10 min read',
  },
  {
    slug: 'telc-c1-sprechen-sample-exams',
    title: 'telc C1 Hochschule Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete telc C1 Hochschule oral exam samples: presentation sheets for both candidates, the discussion quote, model presentations, summaries and a full discussion with the key phrases marked, plus a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "telc c1 hochschule mündliche prüfung beispiel".
    metaDescription:
      'telc C1 Hochschule Sprechen sample exams: real-format sheets for Präsentation, Zusammenfassung and Diskussion, model answers with the key phrases marked, scoring and a printable PDF.',
    category: 'TELC C1',
    date: '2026-09-23',
    dateFormatted: '23. September 2026',
    image: `/images/blog/sprechen/telc-c1/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'telc C1 Hochschule oral exam sheets with a presentation task and a discussion quote lying on a desk',
    readTime: '12 min read',
  },
  {
    slug: 'goethe-b1-sprechen-sample-exams',
    title: 'Goethe B1 Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete Goethe-Zertifikat B1 speaking samples: the planning task and the five-slide presentation sheets, a model dialogue for every part with the reusable phrases marked, and a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "goethe b1 sprechen beispiel".
    metaDescription:
      'Goethe B1 Sprechen sample exams: real-format sheets for planning, presentation and feedback, model dialogues with the key phrases marked, scoring and a printable PDF.',
    category: 'Goethe B1',
    date: '2026-09-26',
    dateFormatted: '26. September 2026',
    image: `/images/blog/sprechen/goethe-b1/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'Goethe-Zertifikat B1 speaking sheets with a planning task and presentation slides lying on a desk',
    readTime: '12 min read',
  },
  {
    slug: 'goethe-b2-sprechen-sample-exams',
    title: 'Goethe B2 Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete Goethe-Zertifikat B2 speaking samples: the talk topics for both candidates, the discussion sheet, model talks, follow-up questions and a full debate with the key phrases marked, plus a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "goethe b2 sprechen beispiel".
    metaDescription:
      'Goethe B2 Sprechen sample exams: real-format sheets for Vortrag and Diskussion, model talks and debates with the key phrases marked, scoring and a printable PDF.',
    category: 'Goethe B2',
    date: '2026-09-30',
    dateFormatted: '30. September 2026',
    image: `/images/blog/sprechen/goethe-b2/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'Goethe-Zertifikat B2 speaking sheets with presentation topics and a discussion question lying on a desk',
    readTime: '12 min read',
  },
  {
    slug: 'goethe-c1-sprechen-sample-exams',
    title: 'Goethe C1 Sprechen: 3 Sample Exams with Model Answers (2026)',
    excerpt:
      'Three complete Goethe-Zertifikat C1 speaking samples: both talk topics, the discussion sheet, two five-minute model talks with questions and a full discussion, the key phrases marked, plus a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "goethe c1 sprechen beispiel".
    metaDescription:
      'Goethe C1 Sprechen sample exams: real-format sheets for Vortrag and Diskussion, model talks and discussions with the key phrases marked, scoring and a printable PDF.',
    category: 'Goethe C1',
    date: '2026-10-03',
    dateFormatted: '3. October 2026',
    image: `/images/blog/sprechen/goethe-c1/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'Goethe-Zertifikat C1 speaking sheets with a talk topic and a discussion task lying on a desk',
    readTime: '14 min read',
  },
  {
    slug: 'osd-b1-sprechen-sample-exams',
    title: 'ÖSD B1 Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete ÖSD Zertifikat Deutsch Österreich B1 speaking samples: the task sheet, both info sheets with three opinions each, a model dialogue for every task with the reusable phrases marked, and a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "ösd b1 sprechen beispiel".
    metaDescription:
      'ÖSD B1 (ZDÖ) Sprechen sample exams: real-format sheets for Kontaktaufnahme, Gespräch über ein Thema and planning, model dialogues with the key phrases marked, scoring and a printable PDF.',
    category: 'ÖSD B1',
    date: '2026-10-07',
    dateFormatted: '7. October 2026',
    image: `/images/blog/sprechen/osd-b1/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'ÖSD B1 speaking sheets with a note card and three portraits lying on a desk',
    readTime: '10 min read',
  },
  {
    slug: 'osd-b2-sprechen-sample-exams',
    title: 'ÖSD B2 Sprechen: 3 Sample Exams with Model Dialogues (2026)',
    excerpt:
      'Three complete ÖSD Zertifikat B2 speaking samples: both task sheets, the photo page, model dialogues for the train conversation, the photo descriptions and the debate, the key phrases marked, plus a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "ösd b2 sprechen beispiel".
    metaDescription:
      'ÖSD B2 Sprechen sample exams: real-format sheets for Kennenlernen, Bildbeschreibung and Meinungsaustausch, model dialogues with the key phrases marked, scoring and a printable PDF.',
    category: 'ÖSD B2',
    date: '2026-10-10',
    dateFormatted: '10. October 2026',
    image: `/images/blog/sprechen/osd-b2/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'ÖSD B2 speaking task sheet and photo page lying on a desk',
    readTime: '12 min read',
  },
  {
    slug: 'osd-c1-sprechen-sample-exams',
    title: 'ÖSD C1 Sprechen: 3 Sample Exams with Model Answers (2026)',
    excerpt:
      'Three complete ÖSD Zertifikat C1 speaking samples: the phone task, the photo discussion and the short-talk handouts, model dialogues and a full Kurzreferat for each, the key phrases marked, plus a printable PDF.',
    // Written for the SERP, not the blog index. Target query: "ösd c1 sprechen beispiel".
    metaDescription:
      'ÖSD C1 Sprechen sample exams: real-format sheets for the phone call, the photo discussion and the Kurzreferat, model answers with the key phrases marked, scoring and a printable PDF.',
    category: 'ÖSD C1',
    date: '2026-10-14',
    dateFormatted: '14. October 2026',
    image: `/images/blog/sprechen/osd-c1/muster-1/mockup.jpg?${BLOG_IMAGE_VERSION}`,
    imageAlt: 'ÖSD C1 speaking sheets with a telephone task and short-talk handouts lying on a desk',
    readTime: '14 min read',
  },
];

/**
 * @param {string} slug
 * @returns {typeof BLOG_POSTS[0] | undefined}
 */
export function getPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}
